<template lang="pug">
.main_main_contents
  .page-title
    .title_left
      h2 登録・契約情報
  .x_panel
    .x_content
      table.agreementtable
        tbody
          tr.form-group
            th
              label.control-label(for='group_id') グループID
            td
              input#group_id.form-control.agreementchange(type='text' v-model='group_id' v-bind:class='{invalid:$v.group_id.$dirty && $v.group_id.$invalid}'
              @input='$v.group_id.$touch')
              span.error(v-show='$v.group_id.$dirty && $v.group_id.$invalid')
                p(v-show='!$v.group_id.required') 必須項目です
                p(v-show='!$v.group_id.maxLength') 20文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='contractor_name') 契約者名
            td
              input#contractor_name.form-control.agreementchange(type='text' v-model='contractor_name' v-bind:class='{invalid:$v.contractor_name.$dirty && $v.contractor_name.$invalid}'
              @input='$v.contractor_name.$touch')
              span.error(v-show='$v.contractor_name.$dirty && $v.contractor_name.$invalid')
                p(v-show='!$v.contractor_name.required') 必須項目です
                p(v-show='!$v.contractor_name.maxLength') 20文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='contractor_kana') フリガナ
            td
              input#contractor_kana.form-control.agreementchange(type='text' v-model='contractor_kana' v-bind:class='{invalid:$v.contractor_kana.$dirty && $v.contractor_kana.$invalid}'
              @input='$v.contractor_kana.$touch')
              span.error(v-show='$v.contractor_kana.$dirty && $v.contractor_kana.$invalid')
                p(v-show='!$v.contractor_kana.required') 必須項目です
                p(v-show='!$v.contractor_kana.maxLength') 20文字以下で入力してください
                p(v-show='!$v.contractor_kana.kana') 全角カナで入力してください
          tr.form-group
            th
              label.control-label(for='zip_code') 住所&nbsp;郵便番号
            td
              input#zip_code.form-control.agreementchange(type='text' v-model='zip_code' v-bind:class='{invalid:$v.zip_code.$dirty && $v.zip_code.$invalid}'
              @input='$v.zip_code.$touch')
              span.error(v-show='$v.zip_code.$dirty && $v.zip_code.$invalid')
                p(v-show='!$v.zip_code.required') 必須項目です
                p(v-show='!$v.zip_code.maxLength') 8文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='pref') 都道府県
            td
              input#pref.form-control.agreementchange(type='text' v-model='pref' v-bind:class='{invalid:$v.pref.$dirty && $v.pref.$invalid}'
              @input='$v.pref.$touch')
              span.error(v-show='$v.pref.$dirty && $v.pref.$invalid')
                p(v-show='!$v.pref.required') 必須項目です
                p(v-show='!$v.pref.maxLength') 10文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='city') 市区町村
            td
              input#city.form-control.agreementchange(type='text' v-model='city' v-bind:class='{invalid:$v.city.$dirty && $v.city.$invalid}'
              @input='$v.city.$touch')
              span.error(v-show='$v.city.$dirty && $v.city.$invalid')
                p(v-show='!$v.city.required') 必須項目です
                p(v-show='!$v.city.maxLength') 20文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='address1') 番地
            td
              input#address1.form-control.agreementchange(type='text' v-model='address1' v-bind:class='{invalid:$v.address1.$dirty && $v.address1.$invalid}'
              @input='$v.address1.$touch')
              span.error(v-show='$v.address1.$dirty && $v.address1.$invalid')
                p(v-show='!$v.address1.required') 必須項目です
                p(v-show='!$v.address1.maxLength') 50文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='address2') 建物名
            td
              input#address2.form-control.agreementchange(type='text' v-model='address2' v-bind:class='{invalid:$v.address2.$invalid}')
              span.error(v-show='$v.address2.$dirty && $v.address2.$invalid')
                p(v-show='!$v.address2.maxLength') 50文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='mail') メールアドレス
            td
              input#mail.form-control.agreementchange(type='text' v-model='mail' v-bind:class='{invalid:$v.mail.$dirty && $v.mail.$invalid}'
              @input='$v.mail.$touch')
              span.error(v-show='$v.mail.$dirty && $v.mail.$invalid')
                p(v-show='!$v.mail.required') 必須項目です
                p(v-show='!$v.mail.maxLength') 50文字以下で入力してください
                p(v-show='!$v.mail.email') 不正なメールアドレスです
          tr.form-group
            th
              label.control-label(for='tel') TEL
            td
              input#tel.form-control.agreementchange(type='text' v-model='tel' v-bind:class='{invalid:$v.tel.$dirty && $v.tel.$invalid}'
              @input='$v.tel.$touch')
              span.error(v-show='$v.tel.$dirty && $v.tel.$invalid')
                p(v-show='!$v.tel.required') 必須項目です
                p(v-show='!$v.tel.maxLength') 20文字以下で入力してください
          tr.form-group
            th
              label.control-label(for='fax') FAX
            td
              input#fax.form-control.agreementchange(type='text' v-model='fax' v-bind:class='{invalid:$v.fax.$invalid}')
              span.error(v-show='$v.fax.$invalid')
                p(v-show='!$v.fax.maxLength') 20文字以下で入力してください
          tr
            th
              label 契約プラン / 支払い方法
            td
              span {{ plan | plan_name }} / {{ payment_plan | payment_plan_name }}
              a(href='http://startup.racooo.com/plan_change', type='button') 契約プラン及び支払い方法の変更はこちら
          tr
            th
              label 契約開始日
            td {{ contract_start_date }}
          tr
            th
              label 契約終了予定日
            td {{ expiration_date }}
    button.customsmallbutton.btn.btn-success(type='button' @click="update") 更新
    // button.customsmallbutton.btn.btn-info(href='#', type='button') 保存
    p 変更後は契約内容変更をクリックしてください。
      br
      br
      | 不明な点につきましては、お手数ですが事務局までお問い合わせください。
    a.customsmallbutton.btn.btn-primary(href='http://startup.racooo.com/inquiry', type='button') お問い合わせはこちら
</template>

<script>
import Authenticate from '@/service/Authenticate'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import { kana } from '@/validators'

export default {
  data () {
    return {
      group_id: null,
      contractor_name: null,
      contractor_kana: null,
      zip_code: null,
      pref: null,
      city: null,
      address1: null,
      address2: null,
      mail: null,
      tel: null,
      fax: null,
      plan: 1,
      payment_plan: 1,
      contract_start_date: null,
      expiration_date: null
    }
  },
  // 入力チェック
  validations: {
    group_id: { required, maxLength: maxLength(20) },
    contractor_name: { required, maxLength: maxLength(50) },
    contractor_kana: { required, maxLength: maxLength(100), kana },
    zip_code: { required, maxLength: maxLength(8) },
    pref: { required, maxLength: maxLength(10) },
    city: { required, maxLength: maxLength(50) },
    address1: { required, maxLength: maxLength(200) },
    address2: { maxLength: maxLength(200) },
    mail: { required, maxLength: maxLength(200), email },
    tel: { required, maxLength: maxLength(30) },
    fax: { maxLength: maxLength(30) }
  },
  mounted () {
    this.bind()
  },
  methods: {
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let result = axios.get('/contract')
      let vue = this
      vue.contract = []
      result.then((res) => {
        // vue.$set(vue, 'contract', res.data)
        for (let key in res.data) {
          vue[key] = res.data[key]
        }
        this.$nextTick(() => { Loader.hide() })
      })
    },
    // updateする
    update () {
      // 入力チェック
      if (this.$v.$invalid) {
        Message.show('error', ['入力内容に不備があります'])
        return false
      }

      // データ送信
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let currentUser = Authenticate.currentUser()
      let self = this
      axios.put('/contract',
        qs.stringify({
          contract: JSON.stringify(this._data),
          user: JSON.stringify(currentUser)
        })
      ).then((res) => {
        Message.show('success', ['更新しました'])
        self.bind()
      }).catch((res) => {
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        alert(res.response.data.message)
      })
    }
  },
  components: {
  },
  filters: {
    plan_name: function (value) {
      if (value === '1') {
        return 'トライアル'
      } else if (value === '2') {
        return 'ベーシック'
      } else if (value === '3') {
        return 'スタンダード'
      } else if (value === '4') {
        return 'プロフェッショナル'
      } else {
        return ''
      }
    },
    payment_plan_name: function (value) {
      if (value === '1') {
        return '月払い'
      } else if (value === '2') {
        return '年払い'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.agreementchange
  width: 300px
  height: 80%
.agreementtable
  td, th
    padding: 8px 0px 8px 0px
  th
    width: 150px
    text-align: left
  td
    width: 200px
    a
      display: block
  input[type='text']
    font-size: 15px
  .error
    padding: 0px 10px
</style>



// WEBPACK FOOTER //
// Agreement.vue?6105a99c